/** @format */
import { css } from 'styled-components';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = () => css`
    padding-left: 0;

    h3 {
        display: inline;
        margin-right: 1.2rem;
        color: var(--colors-text-secondary);
    }

    .criteria-box {
        margin: 0 0.8rem 0.8rem 0;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

export const styles = () => css`
    ${baseStyles()}
`;
